import { useMemo, useState } from 'react';

import { shuffle } from 'lodash-es';
import { FormProvider, useForm } from 'react-hook-form';

import styles from './MarketingPoll.module.css';
import PollOptionButton, { TPollOption } from './PollOptionButton';
import PollOptionDetail from './PollOptionDetail';

export type TMarketingForm = {
  answer: string;
  detail?: string;
};

export const UK_MARKETING_POLL: TPollOption[] = [
  { id: 'ai', name: 'AI Chatbot' },
  { id: 'events', name: 'Events' },
  { id: 'radio', name: 'Radio' },
  { id: 'social_media', name: 'Social media' },
  { id: 'in_the_news', name: 'In the news' },
  { id: 'letter', name: 'Letter' },
  { id: 'train_or_bus_ad', name: 'Bus, Tube or Rail advert' },
  { id: 'search_engine', name: 'Search engine' },
  { id: 'word_of_mouth', name: 'Word of mouth' },
  { id: 'youtube', name: 'YouTube' },
  { id: 'other', name: 'Other' },
];

const MarketingPoll = () => {
  const [submitPoll, setSubmitPoll] = useState(false);

  const methods = useForm<TMarketingForm>();

  const { watch, handleSubmit } = methods;

  const pollOptions = useMemo(() => {
    const options = UK_MARKETING_POLL.filter((item) => item.id !== 'other');
    const otherOption = UK_MARKETING_POLL.find((item) => item.id === 'other');

    const shuffledOptions = shuffle(options);

    return otherOption ? [...shuffledOptions, otherOption] : shuffledOptions;
  }, []);

  const onSubmit = (payload: TMarketingForm) => {
    if (!payload.answer) return;

    if (payload.answer) {
      sessionStorage.setItem('marketing_poll_answer', payload.answer || '');
    }

    if (payload.detail) {
      sessionStorage.setItem('marketing_poll_detail', payload.detail);
    }

    if (payload.answer === 'other' && !payload.detail) return;

    setSubmitPoll(true);
  };

  if (submitPoll) {
    return (
      <section>
        <h3>Thank you!</h3>
        <p>We value your input.</p>
      </section>
    );
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <section>
          <h3>Can you tell us where you heard about iwoca?</h3>
          <div
            data-testid="marketing-poll"
            className={styles.marketingPollContainer}
          >
            {pollOptions.map((poll: TPollOption) => {
              return (
                <PollOptionButton
                  key={poll.id}
                  option={poll}
                  onChange={handleSubmit(onSubmit)}
                />
              );
            })}
          </div>
        </section>
        {watch('answer') === 'other' && <PollOptionDetail />}
      </form>
    </FormProvider>
  );
};

export default MarketingPoll;
